import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import type { LocationChangeParams } from "models/params/location-change-params";

const useOnLocationChange = (): LocationChangeParams => {
  const location = useLocation();
  const [locationPath, setLocationPath] = useState(location.pathname);
  const [queryParams, setQueryParams] = useState(location.search);

  const onLocationChange = (newLocation: typeof location) => {
    const locationPathName = newLocation.pathname;
    setLocationPath(locationPathName);
    const queryParameters = newLocation.search;
    setQueryParams(queryParameters);
  };

  useEffect(() => {
    onLocationChange(location);
  }, [location]);
  return { locationPath, queryParams };
};

export default useOnLocationChange;
